// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"4db5483b","276":"f9c5f17b","284":"ca1cdc33","453":"b2ff6985","468":"708b0f63","515":"6d379499","557":"6b3b2d10","631":"672a8f54","636":"aaa8cc69","645":"1af264be","751":"5b3e89f9","782":"beb6a152","966":"3ba51973","989":"48bb2c99"}[chunkId] + ".chunk.js";
};